import React from 'react';
import PropTypes from 'prop-types';
import window from './globalWrappers/window.js';

class View extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      viewLanguage: props.language,
    };
  }

  componentDidMount() {
    window.languageListener?.onLanguageSwitched(x => {
      this.setState({ viewLanguage: x.language});
    });
  }

  render() {
    let {
      viewLanguage,
    } = this.state;

    return (
      <>
        { React.cloneElement(this.props.children, { language: viewLanguage }) }
      </>
    );
  }
}

View.propTypes = {
  children: PropTypes.node.isRequired,
  language: PropTypes.string,
};

export default View;

